export const API_BASE = "https://api.orivfy.com/b2b-sandbox/api";

class ApiService {
  private apiKey: string | null = null;
  private token: string | null = null;

  async login() {
    const response = await fetch(`${API_BASE}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: "xopihex713@emaxasp.com",
        password: "password123",
      }),
    });

    if (!response.ok) {
      const err = await response.text();
      throw new Error(`Login failed: ${response.status} – ${err}`);
    }

    const data = await response.json();
    this.apiKey = data.api_key;
    this.token = data.token;

    return { apiKey: this.apiKey, token: this.token };
  }

  async analyzeText(text: string) {
    if (!this.apiKey || !this.token) throw new Error("Not authenticated");

    const response = await fetch(`${API_BASE}/text/analyze`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": this.apiKey,
        Authorization: `Bearer ${this.token}`,
      },
      body: JSON.stringify({ text }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Analysis failed: ${response.status} – ${error}`);
    }

    return response.json();
  }

  async analyzeLink(url: string) {
    if (!this.apiKey || !this.token) throw new Error("Not authenticated");

    const response = await fetch(`${API_BASE}/text/analyze`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": this.apiKey,
        Authorization: `Bearer ${this.token}`,
      },
      body: JSON.stringify({ url }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Link analysis failed: ${response.status} – ${error}`);
    }

    return response.json();
  }

  async analyzeFile(file: File) {
    if (!this.apiKey || !this.token) throw new Error("Not authenticated");

    const formData = new FormData();
    formData.append("file", file);

    const uploadResponse = await fetch(`${API_BASE}/text/analyze`, {
      method: "POST",
      headers: {
        "x-api-key": this.apiKey,
        Authorization: `Bearer ${this.token}`,
      },
      body: formData,
    });

    if (!uploadResponse.ok) {
      const error = await uploadResponse.text();
      throw new Error(
        `File upload failed: ${uploadResponse.status} – ${error}`
      );
    }

    const uploadData = await uploadResponse.json();

    if (uploadResponse.status !== 202 || !uploadData.status_url) {
      throw new Error("Unexpected upload response format");
    }

    return this.pollFileStatus(uploadData.status_url);
  }

  async analyzeVideoUrl(url: string) {
    if (!this.apiKey || !this.token) throw new Error("Not authenticated");

    const response = await fetch(`${API_BASE}/video/analyze`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": this.apiKey,
        Authorization: `Bearer ${this.token}`,
      },
      body: JSON.stringify({ url }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(
        `Video URL analysis failed: ${response.status} – ${error}`
      );
    }

    const data = await response.json();

    // If it has status_url or upload_status is pending/processing, poll
    if (
      data.status_url ||
      data.upload_status === "pending" ||
      data.upload_status === "processing"
    ) {
      const statusUrl = data.status_url || response.url; // fallback to same endpoint
      return this.pollFileStatus(statusUrl);
    }

    // Otherwise return immediately (has uuid)
    return data;
  }

  async analyzeVideoFile(file: File) {
    if (!this.apiKey || !this.token) throw new Error("Not authenticated");

    const formData = new FormData();
    formData.append("video", file);

    const response = await fetch(`${API_BASE}/video/analyze`, {
      method: "POST",
      headers: {
        "x-api-key": this.apiKey,
        Authorization: `Bearer ${this.token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(
        `Video file analysis failed: ${response.status} – ${error}`
      );
    }

    const data = await response.json();

    // If it has status_url or upload_status is pending/processing, poll
    if (
      data.status_url ||
      data.upload_status === "pending" ||
      data.upload_status === "processing"
    ) {
      const statusUrl = data.status_url || response.url; // fallback to same endpoint
      return this.pollFileStatus(statusUrl);
    }

    // Otherwise return immediately (has uuid)
    return data;
  }
  // ADD THESE TO YOUR EXISTING ApiService class

  async analyzeImageUrl(url: string) {
    if (!this.apiKey || !this.token) throw new Error("Not authenticated");

    const response = await fetch(`${API_BASE}/image/analyze`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": this.apiKey,
        Authorization: `Bearer ${this.token}`,
      },
      body: JSON.stringify({ url }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(
        `Image URL analysis failed: ${response.status} – ${error}`
      );
    }

    return response.json();
  }

  async analyzeImageFile(file: File) {
    if (!this.apiKey || !this.token) throw new Error("Not authenticated");

    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(`${API_BASE}/image/analyze`, {
      method: "POST",
      headers: {
        "x-api-key": this.apiKey,
        Authorization: `Bearer ${this.token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(
        `Image file analysis failed: ${response.status} – ${error}`
      );
    }

    return response.json();
  }
  private async pollFileStatus(statusUrl: string): Promise<any> {
    const maxAttempts = 60;
    const pollInterval = 1000;

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      await new Promise((resolve) => setTimeout(resolve, pollInterval));

      const statusResponse = await fetch(statusUrl, {
        method: "GET",
        headers: {
          "x-api-key": this.apiKey!,
          Authorization: `Bearer ${this.token!}`,
        },
      });

      if (!statusResponse.ok) {
        const error = await statusResponse.text();
        throw new Error(
          `Status check failed: ${statusResponse.status} – ${error}`
        );
      }

      const statusData = await statusResponse.json();

      // Check for failure
      if (
        statusData.status === "failed" ||
        statusData.upload_status === "failed"
      ) {
        throw new Error(statusData.message || "Processing failed");
      }

      // Check for completion - either has explicit completed status OR has uuid (actual result)
      if (
        statusData.status === "completed" ||
        statusData.upload_status === "completed" ||
        statusData.uuid
      ) {
        return statusData;
      }

      // Otherwise still pending/processing, continue polling
    }

    throw new Error("Processing timeout. Please try again.");
  }

  get isAuthenticated() {
    return !!this.apiKey && !!this.token;
  }
}

export const api = new ApiService();
